import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { ReportState } from './state';
import { IMaterial } from '@/interfaces';

const defaultState: ReportState = {
  report_validation: {
    product_validation: false,
    product_messages: [],
    finance_validation: false,
    finance_messages: [],
    financial_info_validation: false,
    financial_info_messages: [],
    fundrasing_validation: false,
    fundrasing_messages: [],
    result_incompleted: false,
  },
  product: null,
  finance: null,
  financialInfoMaterials: null,
  fundraising: null,
  reportData: null,
  reports: null,
  report_id: null,
};

export const reportModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};

export interface IProductResponce {
  id: number;
  company_id: number;
  name: string;
  url: string;
  description: string;
  materials: IMaterial[];
  created_at: string;
  created_by: { id: number };
  updated_at: string;
  updated_by: { id: number };
}

export interface IProductRequest {
  name: string;
  url: string;
  description: string;
}

export interface IProductReport {
  product_id: number;
  productRequest: IProductRequest;
  uploadFiles: File[];
  deleteFileIds: number[];
}

export interface IFinanceResponce {
  id: number;
  company_id: number;
  expect_finance_date: Date;
  expect_finance_amount: number;
  expect_finance_method: string[]
  expect_valuation_pre: number;
  achievement: string;
  use_of_funds: string[];
  materials: IMaterial[];
  created_at: string;
  created_by: { id: number };
  updated_at: string;
  updated_by: { id: number };
}

export interface IFinanceRequest {
  // id: number;
  expect_finance_date: Date | string | null;
  expect_finance_amount: number | null;
  expect_finance_method: string[]
  expect_valuation_pre: number | null;
  achievement: string;
  use_of_funds: string[];
}

export interface IFinanceReport {
  finance_id: number;
  financeRequest: IFinanceRequest;
  uploadFiles: File[];
  deleteFileIds: number[];
}

export interface IFinancialInfoMaterial {
  id: number;
  company_id: number;
  kind: number;
  file_size: number;
  file_name: string;
  mime_type: string;
  created_at: string;
  created_by: { id: number };
  updated_at: string;
  updated_by: { id: number };
}

export type IFinancialInfoMaterialsResponse = IFinancialInfoMaterial[];

export interface IFinancialInfoMaterialReport {
  fs_upload_files: File[];
  fs_delete_file_ids: number[];
  sa_upload_files: File[];
  sa_delete_file_ids: number[];
}

export interface IFundraising {
  id: number | null;
  method: string;
  from_name: string | null;
  amount: number | null;
  payment_date: string | Date | null;
  repayment_date: string | Date | null;
  rescheduled: boolean | null;
  repayment_type: number | null;
  interest_payment_type: number | null;
  valuation_post: number | null;
}

export interface IFundraisingReport {
  fundraised: boolean;
  fundraisings: IFundraising[];
  fundraisingDeleteIds: number[];
}

export interface IFundraisingResponce {
  fundraised: boolean;
  fundraising_json: string;
}

export interface ReportValidation {
  product_validation: boolean;
  product_messages: string[];
  finance_validation: boolean;
  finance_messages: string[];
  financial_info_validation: boolean;
  financial_info_messages: string[];
  fundrasing_validation: boolean;
  fundrasing_messages: string[];
  result_incompleted: boolean;
}